import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type GetToursResult = { success: true; errors: null } | { success: false; errors: MutationHandlerError }

// Holt fehlende Strecken der Restaurants in die Gemeinden; Fahrzeit und Deckungsbeitrag führt Apollo
// per id in die Anbieterliste aus useSettlements, ein Rückgabewert wird deshalb nicht gebraucht.
const getTours = async ({
	slugs,
	settlementIds,
}: {
	slugs: string[]
	settlementIds: string[]
}): Promise<GetToursResult> => {
	try {
		const { errors } = await client.mutate({
			mutation: gql`
				mutation GetTours($slugs: [String!]!, $settlementIds: [ID!]!) {
					getTours(slugs: $slugs, settlementIds: $settlementIds) {
						slug
						settlementId
						provider {
							id
							driveDistanceKm
							driveMinutes
							singleOrderMarginShare
						}
					}
				}
			`,
			variables: { slugs, settlementIds },
			errorPolicy: 'all',
		})

		return errors ? { success: false, errors } : { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default getTours
